import React, { useEffect } from "react";
import Breadcrumb from "./Breadcrumb";
import SearchBar from "./SearchBar";
import messages from "components/messagesDescription";
import PropTypes from "prop-types";
import withMatchMediaProps from "@hocs/with-match-media-props";
import { withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import CarouselContainer from "../common/global-carousel/CarouselContainer";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProviderDetail,
  fetchProviderProducts,
  clearProviderProducts,
} from "../../actions/marketplaceActions";
import ProductItem from "./ProductItem";
import { Button } from "cxa-components";
import { Link } from "react-router-dom";

const ProviderPage = ({ intl, ...props }) => {
  const dispatch = useDispatch();
  const providerId = props.match.params.providerId;

  const providerDetails = useSelector(state => state.marketplace.selectedProvider);
  const providerProducts = useSelector(state => state.marketplace.providerProducts);
  const isFetching = useSelector(state => state.marketplace.isFetching);

  useEffect(() => {
    if (providerProducts && providerProducts.initRender) {
      dispatch(fetchProviderDetail(providerId));
      dispatch(fetchProviderProducts(providerId, providerProducts.params));
    }
    return () => {
      dispatch(clearProviderProducts());
    };
  }, [providerId]);

  const loadMoreProducts = () => {
    !isFetching && dispatch(fetchProviderProducts(providerId, providerProducts.params));
  };

  const formatAddress = address => {
    let addressString = "";

    const addField = field => {
      if (field !== null && field !== undefined && field !== "") {
        if (addressString) {
          addressString += ", " + field;
        } else {
          addressString += field;
        }
      }
    };

    addField(address.locationName);
    addField(address.street1);
    addField(address.street2);
    addField(address.country);
    addField(address.postalCode);
    addField(address.phoneNumber);
    addField(address.emailAddress);

    return addressString;
  };
  return (
    <article>
      <div className="marketplace-container">
        <SearchBar {...props} />
        <Breadcrumb
          intl={intl}
          pageLabel={intl.formatMessage(messages.marketplace.providerDetailLabel)}
        />
        <header className="product-detail-header">
          <strong>{intl.formatMessage(messages.marketplace.providerInfoLabel)}:</strong>
        </header>
        <div className="product-container">
          <div className="product-summary">
            <section className="img-carousel">
              {
                <CarouselContainer
                  images={[providerDetails.imageMain]}
                  hasArrow={true}
                  width={"20rem"}
                  height={"20rem"}
                  paginationPosition={{ left: "30%", top: "90%" }}
                />
              }
            </section>
            <table>
              {providerDetails.providerName && (
                <tr>
                  <td>{intl.formatMessage(messages.marketplace.providerNameLabel)}:</td>
                  <td>
                    <strong>{providerDetails.providerName}</strong>
                  </td>
                </tr>
              )}
              {providerDetails.registrationNumber && (
                <tr>
                  <td>
                    {intl.formatMessage(messages.marketplace.providerRegistrationNumberLabel)}:
                  </td>
                  <td>
                    <strong>{providerDetails.registrationNumber}</strong>
                  </td>
                </tr>
              )}
              {providerDetails.website && (
                <tr>
                  <td>{intl.formatMessage(messages.websiteDescription)}</td>
                  <td>
                    <Link
                      style={{ color: "#000" }}
                      to={{
                        pathname: !providerDetails.website.match(/^[a-zA-Z]+:\/\//)
                          ? `http://${providerDetails.website}`
                          : providerDetails.website,
                      }}
                      target="_blank"
                    >
                      <strong>{providerDetails.website}</strong>
                    </Link>
                  </td>
                </tr>
              )}
            </table>
          </div>

          {/* DETAIL */}
          <div className="product-detail">
            <section>
              <h3>{providerDetails.providerName}</h3>
            </section>
            <section>
              <h3> {intl.formatMessage(messages.aboutDescription)}</h3>
              <div dangerouslySetInnerHTML={{ __html: providerDetails.body }}></div>
            </section>
            <section>
              <h3>{intl.formatMessage(messages.termsAndConditions)}</h3>
              <div dangerouslySetInnerHTML={{ __html: providerDetails.termsAndConditions }}></div>
            </section>
            {providerDetails.providerLocationModelList &&
              providerDetails.providerLocationModelList.length > 0 && (
                <section>
                  <h3>{intl.formatMessage(messages.locationDescription)}</h3>
                  <div>
                    {providerDetails.providerLocationModelList.map((location, index) => (
                      <div key={index} className="product-section">
                        <div className="product-section-header">
                          <p>{formatAddress(location)}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </section>
              )}
          </div>
        </div>
        <div className="product-list-container">
          <strong>
            <u style={{ marginLeft: "10px" }}>
              {intl.formatMessage(messages.marketplace.offersDescription)}
            </u>
          </strong>
          <div className="card-container">
            {providerProducts &&
              providerProducts.data.map(item => {
                return <ProductItem key={item.productId} product={item} providerId={providerId} />;
              })}
          </div>
          {providerProducts.showMore && (
            <Button onClick={loadMoreProducts} primary className="load-more-btn">
              {intl.formatMessage(messages.marketplace.seeMoreLabel)}
            </Button>
          )}
        </div>
      </div>
    </article>
  );
};

ProviderPage.propTypes = {
  intl: PropTypes.object,
};

export default withMatchMediaProps({
  isNarrowScreen: {
    maxWidth: 680,
  },
})(withRouter(injectIntl(ProviderPage)));



// WEBPACK FOOTER //
// ./components/marketplace/ProviderPage.jsx